import React from 'react';
import { ControlsCell, DateCell, FormatCell, NameCell, Wrapper } from './card-own-order.styles';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { StatusInfoOutline } from '@vtbhome/juicyfront/indexIcon';
import { CardOwnOrderProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { datePeriod } from '@shared/lib/utils/date/date';
import { Tag } from '@shared/ui/tag/tag';
import { ownOrderTag } from '@entities/order/libs/utils/own-order-tag/own-order-tag';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';
import { ROUTE_ADMIN_PRODUCT_BASE } from '@shared/config/routes/routes';

export const CardOwnOrder: React.FC<CardOwnOrderProps> = ({ hasBorder = true, product, onPrefetchProduct }) => {
    const redirect = useRedirect();
    const formatTag = ownOrderTag(product);

    const handleInfo = () => {
        redirect({ url: `${ROUTE_ADMIN_PRODUCT_BASE}/${product.id}` });
    };

    return (
        <Wrapper hasBorder={hasBorder}>
            <NameCell>
                <Typography size='body2_long' color='neutral_50'>
                    Название
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {product.name}
                </Typography>
            </NameCell>
            <FormatCell>
                <Typography size='body2_long' color='neutral_50'>
                    Формат
                </Typography>
                <Tag variant={formatTag.variant}>
                    <Typography size='body2_short' color='neutral_90'>
                        {formatTag.text}
                    </Typography>
                </Tag>
            </FormatCell>
            <DateCell>
                <Typography size='body2_long' color='neutral_50'>
                    Даты
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {datePeriod(product.startAt || '', product.endAt || '')}
                </Typography>
            </DateCell>
            <ControlsCell>
                <Tooltip>
                    <Button
                        size='s'
                        buttonType='secondary'
                        startAdornment={<StatusInfoOutline size='xxs' />}
                        onClick={handleInfo}
                        onMouseEnter={onPrefetchProduct}
                    />
                    <Typography size='body2_short' align='center' as='p'>
                        {`Информация\nо продукте`}
                    </Typography>
                </Tooltip>
            </ControlsCell>
        </Wrapper>
    );
};
